import { store } from '@/store/store';
import { Base64 } from 'js-base64';
const preview = (idfile: any, cnamefile: any) => {
  var originUrl = store.state.config.infile + '?idfile=' + idfile + '&idfed=' + store.state.user.idfed
   + '&id=' + store.state.user.id + '&idappset=' + store.state.config.idappset 
   + '&idtoken=' + store.state.user.idtoken + '&cip=' + store.state.config.ip;
  var previewUrl = originUrl + '&fullfilename=' + cnamefile;
  console.log(previewUrl);
  window.open(store.state.config.file + '?url=' + encodeURIComponent(Base64.encode(previewUrl)));
  return
}
export default preview